import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async getOrganisationServiceTemplates({ organisationId }) {
    try {
      const response = await axiosPrivate.get(`/chains/${organisationId}/service-template`);

      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
      throw error;
    }
  },

  async getServicesByMasterServiceAndOrganisation({ masterServiceId, organisationId, limit }) {
    try {
      const response = await axiosPrivate.get(
        `/v3/service-directory/master-services/${masterServiceId}/services?limit=${limit}`,
        {
          headers: {
            'organisation-id': organisationId,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
      throw error;
    }
  },

  async updateServiceTemplate({ organisationId, serviceTemplateId, payload }) {
    const response = await axiosPrivate.put(
      `/v3/pharmacist/organisations/${organisationId}/service-templates/${serviceTemplateId}`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async createServiceTemplate({ organisationId, payload }) {
    const response = await axiosPrivate.post(
      `/v3/pharmacist/organisations/${organisationId}/service-templates`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },
};
